import { MessageService } from 'primeng/api';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GlobalUtils } from 'src/app/utils/global-utils';
import { EnvironmentService } from 'src/app/services/environment.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import {
    SourceAuthoritesAfterAuthenticationService
} from "../../services/auth/source-authorites-after-authentication.service";

@Component({
  selector: 'app-main-home',
  templateUrl: './main-home.component.html',
  styleUrls: ['./main-home.component.scss'],
  providers: [MessageService]
})
export class MainHomeComponent implements OnInit{
  menuConfig:any;
  showBlocRemb: boolean =true;
  constructor(protected sourceAuh: SourceAuthoritesAfterAuthenticationService,private router : Router,
    private activatedRoute:ActivatedRoute, private messageService:MessageService, private readonly environmentService: EnvironmentService, private configurationService: ConfigurationService) {
    this.isFromCourtier()
    const navigation = this.router.getCurrentNavigation();
    const state = navigation.extras.state as { renitPasswordOK: boolean };
    state?.renitPasswordOK == true ? setTimeout(() => {
      this.messageService.add({
        key: 'SUCCESS_RENIT_PASSWORD',
        severity: 'success',
        summary: 'Confirmation',
        detail: 'Votre mot de passe a été modifié avec succès'
      });
    }, 50) : null;
  }

  async ngOnInit(): Promise<void> {
    this.menuConfig = await this.waitForLocalStorageValue();
  }

  waitForLocalStorageValue(timeout: number = 5000): Promise<string | null> {
    return new Promise((resolve) => {
      const intervalTime = 100;
      let elapsedTime = 0;
  
      const interval = setInterval(() => {
        const value = JSON.parse(GlobalUtils.getStorageItem('router'));
        if (value) {
          clearInterval(interval);
          resolve(value);
        } else {
          elapsedTime += intervalTime;
          if (elapsedTime >= timeout) {
            clearInterval(interval);
          }
        }
      }, intervalTime);
    });
  }

  configuration = this.configurationService.get();
  companySiteId = this.environmentService.get().companySiteIdentifier;

    private isFromCourtier() {
        if(this.sourceAuh.accessDenied && this.configuration.showRemboursement) {
                this.showBlocRemb = !this.configuration.showRemboursement;
        }
    }
}
